// Generated by ReScript, PLEASE EDIT WITH CARE

import * as $$String from "../../../../../../node_modules/rescript/lib/es6/string.js";
import * as Config$PorterinUtils from "../../../../../../node_modules/@porterin/utils/src/configs/Config.mjs";
import * as Environments$PorterinUtils from "../../../../../../node_modules/@porterin/utils/src/constants/Environments.mjs";
import * as CityConstants$PorterinFeature from "../constants/CityConstants.mjs";

function cityToGeoRegionId(city) {
  if (Config$PorterinUtils.env === Environments$PorterinUtils.staging) {
    $$String.lowercase_ascii(city);
    return 3;
  }
  $$String.lowercase_ascii(city);
  return 3;
}

function geoRegionIdToCity(id) {
  return CityConstants$PorterinFeature.dhaka;
}

function toDisplayCity(city) {
  if (city === CityConstants$PorterinFeature.dhaka) {
    return CityConstants$PorterinFeature.dhaka;
  } else {
    return city;
  }
}

export {
  cityToGeoRegionId ,
  geoRegionIdToCity ,
  toDisplayCity ,
}
/* Config-PorterinUtils Not a pure module */
